// About Client Section JavaScript

document.addEventListener('DOMContentLoaded', function() {
    // Add any specific functionality for about client section
    
    // Example: Animate items on scroll
    const aboutClientItems = document.querySelectorAll('.about-client__item');
    
    if ('IntersectionObserver' in window && aboutClientItems.length > 0) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });

        aboutClientItems.forEach((item, index) => {
            item.style.opacity = '0';
            item.style.transform = 'translateY(20px)';
            item.style.transition = `opacity 0.6s ease ${index * 0.1}s, transform 0.6s ease ${index * 0.1}s`;
            observer.observe(item);
        });
    }

    // Example: Responsive gap adjustment (only for simple style, not blocks)
    function adjustRepeaterGap() {
        const repeater = document.querySelector('.about-client__repeater');
        if (repeater && !repeater.classList.contains('about-client__repeater--blocks')) {
            const items = repeater.querySelectorAll('.about-client__item');
            const screenWidth = window.innerWidth;
            
            if (screenWidth <= 576) {
                repeater.style.flexDirection = 'column';
                repeater.style.gap = '16px';
            } else if (screenWidth <= 768) {
                repeater.style.flexDirection = 'row';
                repeater.style.gap = '24px';
            } else {
                repeater.style.flexDirection = 'row';
                repeater.style.gap = '48px';
            }
        }
    }

    // Call on load and resize
    adjustRepeaterGap();
    window.addEventListener('resize', adjustRepeaterGap);
});
